import { AppMenus } from '@configs/app.menus';
import { MODULES } from '@configs/modules.enum';

export const MODULE_TO_ROUTE: Record<MODULES, string> = {
  [MODULES.PORTFOLIO]: AppMenus[MODULES.PORTFOLIO].path,
  [MODULES.RUG]: AppMenus[MODULES.RUG].path,
  [MODULES.AIVA]: AppMenus[MODULES.AIVA].path,
  [MODULES.COMPANY]: AppMenus[MODULES.COMPANY].path,
  [MODULES.FINANCIAL]: AppMenus[MODULES.FINANCIAL].path,
  [MODULES.DATA_STUDIO]: AppMenus[MODULES.DATA_STUDIO].path,
  [MODULES.SHELL_ADMIN]: AppMenus[MODULES.SHELL_ADMIN].path,
};
